import vortexGlobalProducerClient from '@dbt-labs/vortex';

import environment from '@/environment';

export interface VortexEvent {
  dbt_cloud_account_id: number;
  dbt_cloud_account_identifier: string;
  dbt_cloud_user_id: number;
  dbt_cloud_project_id?: number;
  dbt_cloud_environment_id?: number;
  snowplow_domain_user_id?: string;
  snowplow_domain_session_id?: string;
  session_id?: string;
  referrer_url: string;
}

export const configure = (() => {
  let configured = false;

  return () => {
    if (configured) return;
    configured = true;

    // if VITE_VORTEX_COLLECTOR_BASE_URL is not set, use the default
    // otherwise set the base url to same host so Vite can proxy it and not encounter CORS issues
    let vortexCollectorBaseUrl = undefined;
    if (import.meta.env.VITE_VORTEX_COLLECTOR_BASE_URL) {
      vortexCollectorBaseUrl = window.location.origin;
    }
    vortexGlobalProducerClient.configure({
      maxBatchBytes: 256,
      timeoutSeconds: 10,
      ...(vortexCollectorBaseUrl ? { collectorBaseUrl: vortexCollectorBaseUrl } : {}),
    });
    // eslint-disable-next-line no-console
    console.log(
      'Configured Vortex client with collector URL:',
      vortexGlobalProducerClient.config.collectorBaseUrl +
        vortexGlobalProducerClient.config.collectorPath,
    );
  };
})();

export function getVortexClient() {
  let vortexClient;
  if (import.meta.env.MODE === 'development' && environment.DISABLE_VORTEX) {
    // don't use vortex, but use a stub client to see what would've been sent
    vortexClient = {
      logProto: async (schema: any, msg: any) => {
        // Simulate sending the message to Vortex
        // eslint-disable-next-line no-console
        console.log(
          `Vortex is disabled, logging message of schema ${schema} to Vortex:`,
          msg,
        );
      },
      flush: async () => {
        // Simulate flushing the messages
        // eslint-disable-next-line no-console
        console.log('Flushing messages to Vortex');
      },
    };
  } else {
    configure();
    vortexClient = vortexGlobalProducerClient;
  }
  return vortexClient;
}
